import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollState = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    // If not home page, always set true
    if (pathname !== "/") {
      setIsScrolled(true);
      return;
    }

    // Otherwise, enable scroll detection for home page
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll(); // set initial state on mount
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  return isScrolled;
};

export default useScrollState;
